import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";
import { API_ENDPOINT } from "helpers/Endpoints/endpoints";
import { FilterBuilder } from "helpers/ThunkHelper/FilterBuilder";
// import { FilterBuilder } from "helpers/ThunkHelper/FilterBuilder";

const API_URL = process.env.REACT_APP_BASE_URL;
const TOKEN = "a94c7ac0083ae190f0fe61143a7547799b5334c4";

const headers = {
  Authorization: `Token ${TOKEN}`,
  "Content-Type": "application/json",
};

export const fetchUnits = createAsyncThunk(
  "unit/fetchUnits",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search.trim());
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }

    // if (filters && filters.length > 0) {
    //   // params.append("filters", JSON.stringify(filters));
    //   filters.forEach(
    //     ({
    //       filterField,
    //       filterValue,
    //     }: {
    //       filterField: string;
    //       filterValue: any;
    //     }) => {
    //       if (
    //         filterField &&
    //         filterValue !== undefined &&
    //         filterValue !== null
    //       ) {
    //         if (typeof filterValue === "object" && filterValue !== null) {
    //           // Handle cases like { from_date: ..., to_date: ... }
    //           Object.entries(filterValue).forEach(([key, value]) => {
    //             if (value !== undefined && value !== null && value !== "") {
    //               params.append(key, String(value));
    //             }
    //             if (
    //               (filterValue.from_date || filterValue.to_date) &&
    //               (filterField === "created_at" || filterField === "updated_at")
    //             ) {
    //               if (filterField === "created_at") {
    //                 filterField = "created";
    //               } else {
    //                 filterField = "updated";
    //               }
    //               params.append("filter_by", filterField);
    //             }
    //           });
    //         } else {
    //           // Handle primitive values (string, number)
    //           params.append(filterField, filterValue);
    //         }
    //       }
    //     }
    //   );
    // }
    const filterPayload = FilterBuilder(filters ?? []);

    const body = {
      filters: filterPayload,
    };
    const response: any = await Axios.post(
      `${API_ENDPOINT.MASTERS.UNIT.LIST}?${params.toString()}`,
      body,
    );
    return {
      data: response.data.data || [],
      rowCount: response.data.count || 0,
    };
  },
);

export const fetchUnitById = createAsyncThunk(
  "unit/fetchById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.get(
        API_ENDPOINT.MASTERS.UNIT.DETAIL(id),
      );
      return response.data.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch Unit by ID",
      );
    }
  },
);

export const fetchUOMByDropDown = createAsyncThunk(
  "UOM/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(API_ENDPOINT.MASTERS.UNIT.DROPDOWN);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch UOM list");
    }
  },
);

export const updateUnit = createAsyncThunk(
  "uom/updateUnit",
  async (data: any, { rejectWithValue }) => {
    try {
      const response: any = await Axios.put(
        API_ENDPOINT.MASTERS.UNIT.UPDATE(data.id),
        data,
      );
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to update Unit");
    }
  },
);

export const updateStatusInUnit = createAsyncThunk(
  "uom/updateStatusInUnit",
  async (data: any) => {
    const payload = { is_active: data.is_active };
    const response: any = await Axios.patch(
      API_ENDPOINT.MASTERS.UNIT.STATUS_UPDATE(data.id),
      payload,
    );
    return response;
  },
);

export const addUnit = createAsyncThunk(
  "uom/adduom",
  async (data: any, { rejectWithValue }) => {
    const payload = {
      unit_name: data.unit_name,
      unit_symbol: data.unit_symbol,
    };
    try {
      const response: any = await Axios.post(
        API_ENDPOINT.MASTERS.UNIT.CREATE,
        payload,
      );
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to add Unit");
    }
  },
);

export const deleteUnit = createAsyncThunk(
  "uom/delete",
  async (id: any, { rejectWithValue }) => {
    try {
      await Axios.delete(API_ENDPOINT.MASTERS.UNIT.DELETE(id));
      return id;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  },
);

// export const exportUnitCSV = async () => {
//   const response = await Axios.get("/unit/?export=csv", {
//     responseType: "blob",
//   });

//   return {
//     blob: response.data,
//     filename:
//       response.headers["content-disposition"]
//         ?.split("filename=")[1]
//         ?.replace(/"/g, "") || "unit.csv",
//   };
// };

export const exportUnitCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: {
    filterField: string;
    filterValue: any;
  }[];
}) => {
  const params = new URLSearchParams();

  params.append("export", "excel");

  if (search) params.append("search", search);

  // -----------------------------
  // Build structured filters body
  // -----------------------------
  const filterPayload = FilterBuilder(filters ?? []);

  const body = {
    filters: filterPayload,
  };

  const response = await Axios.post(
    `${API_ENDPOINT.MASTERS.UNIT.EXPORT}?${params.toString()}`,
    body,
    { responseType: "blob" },
  );

  return {
    blob: response.data,
    filename: `${
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "unit"
    }_${new Date().toISOString().split("T")[0]}.csv`,
  };
};
